<template>  
  <v-alert :value="true" v-if="mission && gliderState" :color="stateColor" type="infos" class="px-2 py-1" outline>
    <v-icon left>{{ stateIcon }}</v-icon>
    {{ stateLabel }}
  </v-alert>    
</template>

<script>
import { GLIDER_MODE } from '@/models/alo/AloMission';

export default {
  name: 'QuickControlStateBar',
  props: {
    mission: { type: Object, required: true },
  },
  computed: {
    alarmActive() {
      return this.mission.alarmStatusLast?.at(0) != 'Ok'
    },
    gliderState() {
      if (this.alarmActive) return 'InspectionNeeded'
      if (this.mission.gliderWaitingMode === GLIDER_MODE.GLIDER_MODE_WAITING_FOR_GO) return 'ReadyToDive'
      if (this.mission.gliderWaitingMode === GLIDER_MODE.GLIDER_MODE_WAITING_FOR_RESUME && (this.mission.yoArray?.slice(-1)?.[0]?.yosCycle ?? 1) === 1) return 'AtSurface'
      if (this.mission.gliderWaitingMode === GLIDER_MODE.GLIDER_MODE_WAITING_FOR_RESUME) return 'WaitingCommands'
      return null
    },
    stateLabel() {
      const map = {
        InspectionNeeded: this.$t('Pilot.QuickControl.StateBar.InspectionNeeded'),
        ReadyToDive: this.$t('Pilot.QuickControl.StateBar.ReadyToDive'),
        AtSurface: this.$t('Pilot.QuickControl.StateBar.AtSurface'),
        WaitingCommands: this.$t('Pilot.QuickControl.StateBar.WaitingCommands'),
      }
      return map[this.gliderState] || ''
    },
    stateColor() {
      const map = {
        InspectionNeeded: 'error',
        ReadyToDive: 'success',
        AtSurface: 'info',
        WaitingCommands: 'warning',
      }
      return map[this.gliderState] || 'grey'
    },
    stateIcon() {
      const map = {
        InspectionNeeded: 'mdi-alert',
        ReadyToDive: 'mdi-arrow-down-circle',
        AtSurface: 'mdi-waves',
        WaitingCommands: 'mdi-clock-outline',
      }
      return map[this.gliderState] || 'mdi-help'
    },
  },
}
</script>
